import { defaultListParams } from '../../../../../../common/filterTable/constants/defaultListParams';
import { cleanParams } from '../../../../../../common/filterTable/helpers/cleanParams';
import { convertDateStringOrDateToYearMonth } from '../../../../../../utils/dateUtils';
import { FilterFields } from '../types/FilterFields';
import { GetListParams } from '../types/GetListParams';

const useGetListParams = () => {
  const getListParams = (fields: FilterFields) => {
    const { monthFrom, monthTo, distributorAgentId, programName, pfhNo, rebateMode } = fields;

    const params: GetListParams = {
      ...defaultListParams,
      monthFrom: convertDateStringOrDateToYearMonth(monthFrom),
      monthTo: convertDateStringOrDateToYearMonth(monthTo),
      distributorAgentId,
      programName,
      customerNumber: pfhNo,
      rebateMode,
    };

    return cleanParams(params);
  };

  return {
    getListParams,
  };
};

export default useGetListParams;
